"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionHistory = void 0;
const base_1 = require("./base");
/**
 * Retrieves Collection objects from the history_FormData table through the Collection query endpoint.
 * Relies on a feature of the query endpoint that falls back to querying the history table if no results are found.
 * The 'originalId' field is only present on objects in history_FormData, so filtering on 'originalId' will return historical results.
 */
class IkeObjectCollectionHistory extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'CollectionHistory';
        this.actionName = 'collectionHistory';
        this.cacheKeys['uuid'] = true;
        this.cacheKeys['revision'] = true;
    }
    updateCache(key, result, rest) {
        super.updateCache(key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
    }
}
exports.IkeObjectCollectionHistory = IkeObjectCollectionHistory;
//# sourceMappingURL=collection.history.object.js.map